define('taoQtiItem/qtiCreator/widgets/static/img/states/states',[
    'taoQtiItem/qtiCreator/widgets/states/factory',
    'taoQtiItem/qtiCreator/widgets/static/states/states',
    'taoQtiItem/qtiCreator/widgets/static/img/states/Sleep',
    'taoQtiItem/qtiCreator/widgets/static/img/states/Active'
], function(factory, states){
    return factory.createBundle(states, arguments);
});
